module.exports = __webpack_public_path__ + "img/Books.0da49d53.jpg";